import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { CheckBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useCreateFactoryMutation, useEditFactoryMutation, useLazyGetFactoryDetailQuery } from 'bus/factory/factory';
import { FactoryDetail } from 'bus/factory/types';
import { useLazyReportInvoiceVersionsQuery } from 'bus/report/services/services';
import { InvoiceVersions } from 'bus/report/types';

import { TypeModal } from '../../types';

type DetailModalRoleProps = {
  factory: FactoryDetail | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  type: TypeModal;
};

const initialForm: FactoryDetail = {
  id: null,
  isDeleted: false,
  parentId: null,
  name: '',
  comment: '',
  invoiceVersion: null,
  passportConfiguration: {
    additiveName: '',
    calculateAdditiveWeight: true,
    additiveWeight: 0,
  },
};

const DetailModalRole: FC<DetailModalRoleProps> = ({ changeVisible, factory, refresh, visible, type }) => {
  const [getFactoryDetail] = useLazyGetFactoryDetailQuery();
  const [createFactory, { isLoading: isCreateLoading }] = useCreateFactoryMutation();
  const [editFactory, { isLoading: isEditLoading }] = useEditFactoryMutation();

  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);

  const [getReportInvoiceVersions] = useLazyReportInvoiceVersionsQuery();

  const [form, setForm] = useState<FactoryDetail>(initialForm);
  const [formCreate, setFormCreate] = useState<FactoryDetail>(initialForm);

  const [invoiceVersions, setInvoiceVersions] = useState<InvoiceVersions[]>([]);

  const loadVersions = useCallback(async () => {
    await getReportInvoiceVersions().unwrap().then(setInvoiceVersions);
  }, [getReportInvoiceVersions]);

  useEffect(() => {
    loadVersions();
  }, [loadVersions]);

  const onShown = async () => {
    if (factory?.id) {
      const result = await getFactoryDetail({ id: factory.id });
      if (isSuccess(result)) {
        const data: any = 'data' in result ? (result as any).data : (result as any);
        type === TypeModal.EDIT ? setForm(data) : setFormCreate(data);
      }
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    setFormCreate(initialForm);
    createFacroryGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      if (type === TypeModal.EDIT) {
        await editFactory(form).then((resp: any) => {
          if (isSuccess(resp)) {
            changeVisible(false);
            refresh();
          }
        });
      } else {
        await createFactory({
          parentId: formCreate.id || null,
          comment: form.comment,
          name: form.name,
          invoiceVersion: form.invoiceVersion,
          passportConfiguration: { ...form.passportConfiguration },
        }).then((resp: any) => {
          if (isSuccess(resp)) {
            changeVisible(false);
            refresh();
          }
        });
      }
    }
  };

  const showVariants = !factory || (!factory?.parentId && type !== TypeModal.ADD_PARRENT);

  console.log('factory', factory);
  console.log('type', type);

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Завод"
        width={700}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFacroryGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Наименование" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder=""
                            mode="text"
                            value={form.name}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, name: e }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле наименование" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                        {!factory?.parentId && (
                          <>
                            <AppFiledBox label="Фактическое место погрузки" labelTop>
                              <TextArea
                                stylingMode="underlined"
                                mode="text"
                                value={form.comment || ''}
                                onChange={(e: any) => {
                                  setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                                }}
                              />
                            </AppFiledBox>

                            <AppFiledBox label="Наименование добавки" labelTop>
                              <TextBox
                                stylingMode="underlined"
                                placeholder=""
                                mode="text"
                                value={form.passportConfiguration.additiveName}
                                onValueChange={(e: any) => {
                                  setForm((prev) => ({
                                    ...prev,
                                    passportConfiguration: { ...prev.passportConfiguration, additiveName: e },
                                  }));
                                }}
                              ></TextBox>
                            </AppFiledBox>

                            <AppFiledBox label="" labelTop>
                              <CheckBox
                                value={form.passportConfiguration.calculateAdditiveWeight}
                                text="Рассчитывать объем добавки автоматически"
                                onValueChanged={(e) =>
                                  setForm((prev) => ({
                                    ...prev,
                                    passportConfiguration: {
                                      ...prev.passportConfiguration,
                                      calculateAdditiveWeight: e.value,
                                    },
                                  }))
                                }
                              />
                            </AppFiledBox>
                            {!form.passportConfiguration.calculateAdditiveWeight && (
                              <AppFiledBox label="Объем добавки" labelTop>
                                <NumberBox
                                  stylingMode="underlined"
                                  placeholder="0"
                                  format={MONEY_FORMAT}
                                  value={form.passportConfiguration.additiveWeight}
                                  onValueChanged={(e) => {
                                    setForm((prev) => ({
                                      ...prev,
                                      passportConfiguration: {
                                        ...prev.passportConfiguration,
                                        additiveWeight: e.value,
                                      },
                                    }));
                                  }}
                                ></NumberBox>
                              </AppFiledBox>
                            )}

                            {showVariants && (
                              <AppFiledBox label="Версия накладной" labelTop>
                                <SelectBox
                                  stylingMode="underlined"
                                  items={invoiceVersions}
                                  value={form.invoiceVersion}
                                  valueExpr="id"
                                  displayExpr="name"
                                  searchEnabled
                                  onItemClick={(e) => {
                                    setForm((prev) => ({ ...prev, invoiceVersion: e.itemData.id }));
                                  }}
                                ></SelectBox>
                              </AppFiledBox>
                            )}
                          </>
                        )}
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isCreateLoading || isEditLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
